<template>
    <span class="eml-add-contact">
        <a href="#" @click.prevent="add_contact_handler" v-if="contactText">
            <span class="icon"><i class="fa fa-user"></i></span>
            <span>{{ contactText }}</span>
        </a>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isContactModalActive" has-modal-card>
            <contact-modal
                @contact-added="contact_added_handler"
                :item="contact"
                :show-company-field="true"
                :quick-add="true"
            />
        </o-modal>
    </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import {
    autocomplete_contacts,
    get_names_and_email,
} from './gmail_api'
import { split_fullname } from './utils'
import ContactModal from './../../components/modals/Contact.vue'


export default {
    components: {
        ContactModal,
    },
    computed: {
        ...mapGetters([
            'currentUserId',
        ]),
        suggestions() {
            return [this.search_term, ...this.data.contacts, ...this.data.messages]
        },
    },
    data() {
        return {
            contact: {},
            isContactModalActive: false,
        }
    },
    methods: {
        ...mapActions([
            'fetchCompanyById',
            'fetchContacts',
        ]),
        add_contact_handler() {
            this.load_contact().then(() =>
                autocomplete_contacts(this.contactText).then(contacts => {
                    if (!this.contact.id && Array.isArray(contacts) && contacts.length) {
                        this.contact = contacts[0]
                    }
                }).then(() => {
                    this.isContactModalActive = true
                })
            )
        },
        contact_added_handler(contact_id) {
            this.contact.id = contact_id
        },
        load_contact() {
            if (!this.contactText) {
                return Promise.resolve()
            }
            const [full_name, email] = get_names_and_email(this.contactText),
                [first_name, last_name] = split_fullname(full_name)
            this.contact.first_name = first_name
            this.contact.last_name = last_name
            this.contact.lead_owner = this.currentUserId
            this.contact.email = email
            const promise = new Promise((resolve, reject) => {
                this.fetchContacts({
                    email,
                }).then(res => {
                    if (res.data.data.length) {
                        this.contact = res.data.data[0]
                        this.contact.lead_owner = this.currentUserId
                        this.fetchCompanyById(this.contact.company_id).then(resolve)
                    } else {
                        resolve()
                    }
                })
            })
            return promise
        },
    },
    mounted() {
        this.load_contact()
    },
    props: ['contactText'],
}
</script>

<style>
.clock-buttons-ctn {
  display: flex;
  margin: 0 8px 0 0; }
.clock-buttons-ctn button[disabled] {
  cursor: auto; }

</style>